(function() {
  var ValidationEngine,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ValidationEngine = App.loadClass('core::ValidationEngine');

  exports.AddEditWeightSetDialog = (function(superClass) {
    extend(AddEditWeightSetDialog, superClass);

    function AddEditWeightSetDialog() {
      return AddEditWeightSetDialog.__super__.constructor.apply(this, arguments);
    }

    AddEditWeightSetDialog.prototype.init = function() {
      this.layoutUrl = 'backend/portal/weightings/load-add-edit-dialog';
      this.saveUrl = 'backend/portal/weightings/save-weight-set';
      this.classes = 'small_dialog';
      this.refreshNavHandler = false;
      this.successAction = this.updateTaffy;
      this.createDialog();
      this.validator = new ValidationEngine();
      return this.validator.stopValidating();
    };

    AddEditWeightSetDialog.prototype.afterLoadLayout = function(selector, response) {
      var ref;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        this.openDialog();
        return;
      }
      this.validator.registerRule({
        'selector': '.validate-unique',
        'text': 'Weight Set Name must be unique',
        'ajax': {
          'url': 'backend/portal/weightings/validate-ws-name',
          'data': (function(_this) {
            return function(elem) {
              return {
                'ws_name': elem.val(),
                'pp_id': _this.dialog.find('input[name=pp_id]').val(),
                'ws_id': _this.dialog.find('input[name=ws_id]').val()
              };
            };
          })(this)
        },
        'func': function(data) {
          return data === 'good';
        }
      });
      this.validator.makeFormValidator('addws', '#frm_addws', '#addws_errors', (function(_this) {
        return function(valid) {
          if (valid) {
            return _this.save('Saving...');
          } else {

          }
        };
      })(this));
      this.dialog.find('.save-btn').bind('click', (function(_this) {
        return function() {
          _this.validator.startValidating();
          return _this.validator.validateForm('addws');
        };
      })(this));
      return this.openDialog();
    };

    AddEditWeightSetDialog.prototype.updateTaffy = function(response) {
      var ws;
      ws = response.data;
      if (this.parent.taffyObjects.ws({
        id: ws.id
      }).count()) {
        this.parent.taffyObjects.ws({
          id: ws.id
        }).update(ws);
      } else {
        this.parent.taffyObjects.ws.insert(ws);
      }
      this.parent.renderWeightSetSelect(ws.id);
      return this.parent.renderZoneSelects();
    };

    return AddEditWeightSetDialog;

  })(DialogHandler);

}).call(this);
